// TODO: возможно нужно выпилить
import { format, set, subDays } from 'date-fns';
import { DATE_FORMATS } from 'Utils/formats';
import React from 'react';
import { Button, Dialog, Pane, Strong, Table, Text } from 'evergreen-ui';
import ReactPaginate from 'react-paginate';
import SuspenseSpinner from 'Utils/SuspenseSpinner';
import { VirtualList } from 'Utils/VirtualList';
import { useUrlParams } from 'Utils/useUrlParams';
import { useSelector } from 'react-redux';
import { createUseStyles } from 'react-jss';
import { prefixImageBase64ByFileName } from 'Features/Observations-old/Utils/MessageAttachments';
import { timeZoneSelector } from 'Features/App/appSlice';
import { timeZoneToUTC, UTCtoTimeZone } from 'Utils/UTCConverter';
import MessageFile from 'Features/StationsNew/Station/Messages/Message.File';

const useStyles = createUseStyles({
  imageWrapper: {
    position: 'absolute',
    height: '100%',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    transition: 'all .5s',
    zIndex: 3,
    backgroundColor: '#F9F9FB',
  },
  hover: {
    zIndex: 4,
    '&:hover': {
      zIndex: 5,
    },
    '&:hover + div': {
      width: '100%',
      left: 0,
      backgroundSize: '100% 100%',
      zIndex: 4,
    },
  },
  cardWrapper: {
    display: 'grid',
    gridTemplateRows: '1fr max-content',
    backgroundColor: '#F9F9FB',
    padding: '.5rem',
  },
  displayContents: {
    '& > div': {
      display: 'contents',
    },
  },
});

export const initialParamsState = {
  // -7 дней от сегодняшней даты
  startDate: format(subDays(set(new Date(), { hours: 0, minutes: 0, seconds: 0 }), 7), DATE_FORMATS.inputDatetime),
  endDate: format(new Date(), DATE_FORMATS.inputDatetime),
  size: 50,
  page: 0,
  totalPages: 1,
  channels: (ids) => (ids?.length ? ids : []),
  status: [],
  programs: [],
  formats: [],
  datasourceIds: (ids) => (ids?.length ? ids : []),
  station: null,
  datasource: null,
};

export const OUTGOING = 'outgoing';
export const INCOMING = 'incoming';
export const CHANNEL = 'channel';
export const CUT = 'cut';

const BACK = 'back';
const FORWARD = 'forward';

export const MessagesList = React.memo(({ messages, isLoading, RowTable }) => {
  if (isLoading) return <SuspenseSpinner />;
  if (messages.length === 0) return <Table.Row><Table.Cell><Strong>Нет сообщений</Strong></Table.Cell></Table.Row>;
  return <VirtualList data={messages} row={RowTable} />;
});
MessagesList.displayName = 'MessagesList';

export const TableTextHeader = React.memo(({ headers = [] }) => (
  <Table>
    <Table.Head height="auto" minHeight={40}>
      {React.Children.toArray(headers.map((header) => (
        <Table.HeaderCell style={header.cellProps}>
          <Strong>{header.name}</Strong>
        </Table.HeaderCell>
      )))}
    </Table.Head>
  </Table>
));
TableTextHeader.displayName = 'TableTextHeader';

export function MessagesTable({ params, type, mode, headers, RowCells, useGetMessages, useGetMessageFileQuery }) {
  const [, updateUrlParams] = useUrlParams();
  const [getMessages, { data: { content: messages = [], totalPages } = {}, isFetching: isLoadingMessages }] = useGetMessages();
  const [searchPage, setSearchPage] = React.useState(0);

  const [dialogData, setDialogData] = React.useState(null);

  const onPageChange = ({ selected }) => {
    updateUrlParams({
      page: selected,
    });
    setSearchPage(selected)
  };

  // обработчик для переключения сообщений в диалоге
  // direction === FORWARD - нажали вперед, direction === BACK - нажали назад
  const onChangeMessage = React.useCallback((direction, index) => {
    if (direction === FORWARD) setDialogData({ message: messages[index + 1], index: index + 1, length: messages.length });
    else setDialogData({ message: messages[index - 1], index: index - 1, length: messages.length });
  }, [messages]);

  const RowTable = React.useCallback((message, index, { length } = []) => (
    <Table.Row
      height="auto"
      minHeight={48}
      isSelectable
      onClick={() => setDialogData({ message, index, length })}
    >
      <RowCells message={message} timeZone={params.timeZone} />
    </Table.Row>
  ), [RowCells, params.timeZone]);

  const fetchParams = React.useMemo(() => ({
    startDate: timeZoneToUTC(new Date(params.date.startDate), params.timeZone, DATE_FORMATS.api),
    endDate: timeZoneToUTC(set(new Date(params.date.endDate), { seconds: 59 }), params.timeZone, DATE_FORMATS.api),
    page: searchPage === undefined ? 0 : searchPage,
    size: params.size,
    ...(params.stationId ? { stationId: params.stationId } : {}),
    ...(params.datasourceIds?.length ? { datasourceIds: params.datasourceIds } : {}),
    ...(params.programs.length ? { programIds: params.programs } : {}),
    ...(params.formats.length ? { formatIds: params.formats } : {}),
    ...(params.isStationMessages && params.status.length ? { statusIds: params.status } : {}),
    ...(params.channels.length ? { channelIds: params.channels } : {}),
    ...(params.status.length ? { statusIds: params.status } : {}),
    ...(params.station ? { stationIds: [params.station] } : {}),
    ...(params.datasource ? { datasourceIds: [params.datasource] } : {}),
  }), [params.channels, params.datasource, params.datasourceIds, params.date.endDate, params.date.startDate, params.formats, params.isStationMessages, params.page, params.programs, params.size, params.station, params.stationId, params.status, params.timeZone]);

  React.useEffect(() => {
    getMessages(fetchParams);
  }, [fetchParams, getMessages]);

  return (
    <>
      {mode === 'table' ? (
        <Pane display="grid" rowGap=".5rem">
          <Pane display="grid" gridTemplateRows="max-content 1fr" backgroundColor="white" border>
            <TableTextHeader headers={headers} />
            <MessagesList messages={messages} isLoading={isLoadingMessages} RowTable={RowTable} />
          </Pane>
        </Pane>
      ) : <MessagesCard content={messages} setMessageForDialog={setDialogData} isLoading={isLoadingMessages} />}
      {totalPages > 1 && (
        <ReactPaginate
          forcePage={params.page}
          previousLabel="пред."
          nextLabel="след."
          breakLabel="..."
          breakClassName="break-me"
          pageCount={totalPages || 1}
          marginPagesDisplayed={2}
          pageRangeDisplayed={5}
          onPageChange={onPageChange}
          containerClassName="pagination"
          pageLinkClassName="pageLink"
          subContainerClassName="pages pagination"
          activeClassName="active"
        />
      )}
      {dialogData && (
        <MessageDialog
          message={dialogData}
          type={type}
          closeDialog={() => setDialogData(null)}
          onChangeMessage={onChangeMessage}
          useGetMessageFileById={useGetMessageFileQuery}
          timeZone={params.timeZone}
        />
      )}
    </>
  );
}

const MessageDialog = ({
  message: {
    message = {},
    index,
    length,
  } = {},
  type,
  closeDialog,
  onChangeMessage,
  useGetMessageFileById,
  timeZone,
}) => {
  const classes = useStyles();
  const Footer = React.useMemo(() => (
    <Pane
      diplay="grid"
      gridTemplateColumns="max-content max-content max-content"
      justifyContent="end"
      alignSelf="end"
      padding=".5em"

    >
      <Button
        disabled={!index}
        onClick={() => onChangeMessage(BACK, index)}
      >
        Предыдущее
      </Button>
      <Button
        marginLeft={10}
        disabled={index === null || index === length - 1}
        onClick={() => onChangeMessage(FORWARD, index)}
      >
        Следующее
      </Button>
    </Pane>
  ), [index, length, onChangeMessage]);

  return (
    <Dialog
      isShown
      width="80%"
      topOffset={5}
      title={`Сообщение №${message.id}`}
      onCloseComplete={closeDialog}
      // confirmLabel="Закрыть"
      footer={Footer}
      shouldCloseOnOverlayClick={false}
      contentContainerProps={{
        className: classes.displayContents,
      }}
    >
      <Pane display="grid" overflow="hidden">
        <MessageFile
          messageId={message?.id}
          type={type}
          hasAlternativeMessage
          useGetMessageFileById={useGetMessageFileById}
          timeZone={timeZone}
        />
      </Pane>
    </Dialog>
  );
};

const MessagesCard = React.memo(({ content, setMessageForDialog, isLoading }) => {
  if (isLoading) return <SuspenseSpinner />;
  return (
    <Pane
      display="grid"
      gridTemplateColumns="repeat(3, max-content)"
      justifyContent="center"
      gridGap=".5rem"
      backgroundColor="white"
      padding=".5rem"
      overflow="auto"
      border
    >
      {content.map((message) => (
        <Pane display="grid">
          <CardContent message={message} setMessageForDialog={setMessageForDialog} />
        </Pane>
      ))}
    </Pane>
  );
});
MessagesCard.displayName = 'MessagesCard';

const CardContent = React.memo(({ message, setMessageForDialog }) => {
  const classes = useStyles();
  const { stations: stationsTimezone } = useSelector(timeZoneSelector);

  const filteredContent = React.useMemo(() => message.content?.filter((c) => c.attachment) || [], [message.content]);

  const hasMoreAttachments = React.useMemo(() => filteredContent.length > 3, [filteredContent]);

  const sliced = React.useMemo(() => {
    if (hasMoreAttachments) {
      return filteredContent.slice(0, 3);
    }
    return filteredContent;
  }, [hasMoreAttachments, filteredContent]);

  const getImageBase64 = ({ data, filename, name }) => {
    const prefix = prefixImageBase64ByFileName(filename || name);
    return {
      isPhoto: !!prefix,
      fileData: prefix ? `${prefix}${data}` : filename || name,
    };
  };

  const calculatedWidth = React.useMemo(() => 100 / filteredContent.length || 1, [filteredContent.length]);

  return (
    <Pane className={classes.cardWrapper} elevation={1} onClick={() => setMessageForDialog({ message, index: 0 })}>
      <Pane display="grid" height={300} gridTemplateColumns={hasMoreAttachments ? 'repeat(4, 1fr)' : `repeat(${filteredContent.length}, 1fr)`} position="relative">
        {
          sliced.map((data, index) => {
            const { isPhoto, fileData } = getImageBase64({
              data: data.content.data,
              filename: data.filename,
              name: data.name,
            });
            return (
              <>
                <Pane
                  className={classes.hover}
                  position="absolute"
                  width={`${calculatedWidth}%`}
                  left={`${index * calculatedWidth}%`}
                  height="100%"
                />
                <Pane
                  className={classes.imageWrapper}
                  width={`${calculatedWidth}%`}
                  left={`${index * calculatedWidth}%`}
                  {...(isPhoto ? { background: `url(${fileData})` } : {})}
                  {...(sliced.length === 1 ? { backgroundSize: '100% 100% !important' } : {})}
                >
                  {!isPhoto && <Text fontSize={24} display="grid" alignItems="center" height="100%" textAlign="center">{fileData}</Text>}
                </Pane>
              </>
            );
          })
        }
        {
          hasMoreAttachments && (
            <Pane
              position="absolute"
              width={`${calculatedWidth}%`}
              left={`${sliced.length * calculatedWidth}%`}
              height="100%"
              display="grid"
              justifyContent="center"
              alignItems="center"
              cursor="pointer"
            >
              <Text fontSize={24}>...</Text>
            </Pane>
          )
        }
      </Pane>
      <Pane display="grid">
        <Text>{`Программа: ${message?.program?.name || ''}`}</Text>
        <Text>{`Дата: ${UTCtoTimeZone(message?.dateTime, stationsTimezone, 'dd.MM.yyyy HH:mm:ss')}`}</Text>
        <Text>{`Время разбора: ${UTCtoTimeZone(message?.createDateTime, stationsTimezone, 'dd.MM.yyyy HH:mm:ss')}`}</Text>
        <Text>{`Статус: ${message?.status?.status}`}</Text>
        <Text>{`Формат: ${message?.format?.description || ''}`}</Text>
      </Pane>
    </Pane>
  );
});
CardContent.displayName = 'CardContent';

export const filterStatus = (urlStatuses, isLoading, statuses) => {
  const tmp = [];
  if (urlStatuses?.length > 0 && !isLoading && statuses.length > 0) {
    urlStatuses.forEach((status) => {
      const finded = statuses.find((s) => s.id === status);
      if (finded) {
        tmp.push(status);
      }
    });
    return tmp;
  }
  return tmp;
};
